import { useState, useEffect } from "react";
import { INTERNAL_POST_MESSAGE_EVENT_NAMES } from "../constants";

const { CTRL_INPUT_TYPE_DISPATCH_EVENT } = INTERNAL_POST_MESSAGE_EVENT_NAMES;

const useCtrlInputDispatcher = () => {
  const [ctrlInputDispatchConfig, setCtrlInputDispatchConfig] = useState(null);

  // post messages for allowed input events to parent, if it is initiated by parent
  useEffect(() => {
    if (ctrlInputDispatchConfig) {
      const {
        inputTypes = [],
        sourceWindow,
        sourceOrigin,
      } = ctrlInputDispatchConfig;

      const handlerObjs = inputTypes
        .filter((t) => ["click", "keydown"].includes(t))
        .map((inputType) => {
          const handler = () => {
            sourceWindow.postMessage(
              JSON.stringify({
                eventName: CTRL_INPUT_TYPE_DISPATCH_EVENT,
                inputType,
              }),
              sourceOrigin
            );
          };
          window.addEventListener(inputType, handler);

          return { inputType, handler };
        });

      return () => {
        for (const obj of handlerObjs) {
          const { inputType, handler } = obj;
          window.removeEventListener(inputType, handler);
        }
      };
    }
  }, [ctrlInputDispatchConfig]);

  return setCtrlInputDispatchConfig;
};

export default useCtrlInputDispatcher;
